import { Page } from 'components/Page'
import { PageHeader } from 'components/Shared/PageHeader'
import { PlayerPaybackReportsTabs } from './PlayerPaybackReportsTabs'
import { useParams } from 'react-router-dom'

export const PlayerPaybackReportsHeader = ({
  currentTab,
  children,
}: {
  currentTab: string
  children?: React.ReactNode
}) => {
  const { id } = useParams()

  return (
    <Page
      header={
        <PageHeader
          title="View Player Payback Reports"
          isSecondary={true}
          tabs={
            <PlayerPaybackReportsTabs
              currentTab={currentTab}
              locationId={Number(id)}
            />
          }
        />
      }
    >
      {children}
    </Page>
  )
}
